module.exports = __webpack_public_path__ + "static/media/Character_2.0028cf87.png";